import styled from 'styled-components';
import useSWR from 'swr';
import { Button } from '@yoweb/ui/components/buttons/Button';
import { useTasks } from '@poplar/contexts/TaskContext/TaskProvider';
import { RotateIcon } from '@yoweb/ui/components/Icon/RotateIcon';
import { TodoEditType } from '@poplar/types/enums';
import { useTranslation } from '@yoweb/next-i18next';
import { Text, Title } from '@yoweb/ui/components/typography';
import { Box } from '@yoweb/ui/components/Box';
import { th } from '@yoweb/ui/styles/utils/theme';
import { fetcher } from '@yoweb/utils/common';
import { API_TASKS } from '@poplar/constants/routes';
import Spinner from '@yoweb/ui/components/Spinner';
import { trackEvent } from '@yoweb/utils/analytics/mixpanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RecurringBanner = function RecurringBanner(_ref) {
  var taskFeedback = _ref.taskFeedback,
      onClose = _ref.onClose;

  var _useSWR = useSWR("".concat(API_TASKS, "/").concat(taskFeedback.taskId), fetcher),
      data = _useSWR.data,
      isLoading = _useSWR.isLoading;

  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  var _useTasks = useTasks(),
      openTaskIntakeModal = _useTasks.actions.openTaskIntakeModal;

  if (isLoading) {
    return /*#__PURE__*/_jsx(Box, {
      px: "normal1",
      py: "normal2",
      mt: "large3",
      children: /*#__PURE__*/_jsx(Spinner, {
        size: "lg"
      })
    });
  }

  return /*#__PURE__*/_jsxs(BorderBox, {
    px: "normal1",
    py: "normal2",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    mt: "large3",
    "data-testid": "make-recurring-banner",
    children: [/*#__PURE__*/_jsx(Title, {
      size: "xs",
      as: "h3",
      children: t('recurring.want-to-make-recurring')
    }), /*#__PURE__*/_jsx(Box, {
      mt: "small3",
      children: /*#__PURE__*/_jsx(Text, {
        size: "md",
        textAlign: "center",
        children: t('recurring.turn-recurring')
      })
    }), /*#__PURE__*/_jsx(Box, {
      mt: "normal1",
      children: /*#__PURE__*/_jsx(Button, {
        onClick: function onClick() {
          onClose === null || onClose === void 0 ? void 0 : onClose();
          trackEvent({
            recurringTaskCreation: {}
          });
          openTaskIntakeModal(data === null || data === void 0 ? void 0 : data.task, undefined, {
            editType: TodoEditType.TODO_MAKE_RECURRING
          });
        },
        "data-testid": "make-recurring-button",
        size: "sm",
        iconLeft: /*#__PURE__*/_jsx(RotateIcon, {
          size: 24
        }),
        variant: "secondary",
        children: t('recurring.make-recurring')
      })
    })]
  });
};
var BorderBox = styled(Box).withConfig({
  componentId: "sc-1orvwcc-0"
})(["border:1px solid ", ";border-radius:", ";"], th.getColor('sandDark'), th.getRadii('small'));